const menu = {
  styleOverrides: {
    paper: {
      // This targets Dividers *within* the Menu's paper element
      '& .MuiDivider-root': {
        marginTop: '4px',
        marginBottom: '4px',
      },
      // Optional: override MUI's sibling selector too
      '& .MuiMenuItem-root + .MuiDivider-root': {
        marginTop: '4px',
        marginBottom: '4px',
      },
    },
  },
};

export default menu;